/**
 * Generates a consistent instructor ID for anchor navigation
 * @param index - Zero-based index of the instructor
 * @returns Formatted instructor ID string
 */
export function generateInstructorId(index: number): string {
    return `instructor-${index + 1}`;
}

/**
 * Generates a consistent instructor anchor hash for navigation
 * @param index - Zero-based index of the instructor
 * @returns Formatted instructor anchor hash string with # prefix
 */
export function generateInstructorAnchorHash(index: number): string {
    return `#${generateInstructorId(index)}`;
}
